import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d022386"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "text-with-icon"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "texts"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "header"
}, "No segments"), /*#__PURE__*/_createElementVNode("p", {
  class: "body"
}, [/*#__PURE__*/_createTextVNode("Create segments in the "), /*#__PURE__*/_createElementVNode("b", null, "COGS"), /*#__PURE__*/_createTextVNode(" module to start using the segments filter")])], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "button-text"
}, "Create segment", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search_icon = _resolveComponent("search-icon");
  const _component_stroked_plus_icon = _resolveComponent("stroked-plus-icon");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['empty-segments', {
      big: $props.big
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_search_icon), _hoisted_2]), _createVNode(_component_app_button, {
    v2: "",
    onClick: $options.handleClick
  }, {
    default: _withCtx(() => [_createVNode(_component_stroked_plus_icon, {
      color: "#FFFFFF",
      width: "20",
      height: "20"
    }), _hoisted_3]),
    _: 1
  }, 8, ["onClick"])], 2);
}